// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2981f0c3" + "." + "b3caaeb06f247bec" + ".js";
};